// extracted by mini-css-extract-plugin
export default {"toolBar":"styles_toolBar__xy-TJ","symbolWrapper":"styles_symbolWrapper__DHRyU","logo":"styles_logo__zsZmO","resetTicker":"styles_resetTicker__d2vxE"};